import { render, staticRenderFns } from "./AddonSort.vue?vue&type=template&id=ed38adb8&"
import script from "./AddonSort.vue?vue&type=script&lang=js&"
export * from "./AddonSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports